import { useTranslation } from "react-i18next";
import type { StrengthItem } from "@/lib/types";

export default function Strengths() {
  const { t } = useTranslation();
  const strengthsRaw = t("home.strengths.items", { returnObjects: true }) as unknown as StrengthItem[];
  const strengths = Array.isArray(strengthsRaw) ? strengthsRaw : [];

  return (
    <section className="relative bg-background-100 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="inline-flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500" />
              <span className="text-[11px] tracking-[0.22em] uppercase text-primary-600 font-semibold">
                {t("home.strengths.eyebrow")}
              </span>
            </div>
            <h2 className="mt-4 font-heading font-extrabold text-foreground-950 text-3xl md:text-[42px] leading-tight tracking-tight">
              {t("home.strengths.headline1")}
              <br />
              <span className="text-primary-600">{t("home.strengths.headline2")}</span>
            </h2>
          </div>
          <p className="max-w-md text-sm md:text-base text-foreground-600 leading-relaxed">
            {t("home.strengths.desc")}
          </p>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {strengths.map((s) => (
            <article
              key={s.no}
              className="group relative bg-background-50 rounded-lg border border-background-200/80 p-7 md:p-8 hover:border-primary-300 transition-all duration-300"
            >
              <div className="flex items-start justify-between">
                <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${s.icon} text-xl`} />
                </span>
                <span className="text-[11px] font-mono tracking-widest text-foreground-300">
                  {s.no}
                </span>
              </div>
              <h3 className="mt-7 font-heading font-bold text-foreground-950 text-lg md:text-xl">
                {s.title}
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
              <div className="mt-6 pt-5 border-t border-background-200/80 flex items-center justify-between">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-800 text-[11px] font-medium">
                  {s.tag}
                </span>
                <span className="w-7 h-7 flex items-center justify-center rounded-full text-foreground-400 group-hover:text-primary-600 group-hover:translate-x-0.5 transition-all">
                  <i className="ri-arrow-right-line text-base" />
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}